import type { StoredSession } from './session-types';

const SESSION_KEY = 'payment-plan.session.v1';

export function readStoredSession(): StoredSession | null {
  const rawSession = window.sessionStorage.getItem(SESSION_KEY);
  if (!rawSession) {
    return null;
  }

  try {
    return JSON.parse(rawSession) as StoredSession;
  } catch {
    window.sessionStorage.removeItem(SESSION_KEY);
    return null;
  }
}

export function writeStoredSession(session: StoredSession): void {
  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

/** fix-60 · ADR-018: inmobiliaria elegida por el superadmin en el selector (por pestaña). */
const INMOBILIARIA_ACTIVA_KEY = 'payment-plan.inmobiliaria-activa.v1';

export function readInmobiliariaActiva(): string | null {
  try {
    return window.sessionStorage.getItem(INMOBILIARIA_ACTIVA_KEY);
  } catch {
    return null;
  }
}

export function writeInmobiliariaActiva(id: string | null): void {
  try {
    if (id) {
      window.sessionStorage.setItem(INMOBILIARIA_ACTIVA_KEY, id);
    } else {
      window.sessionStorage.removeItem(INMOBILIARIA_ACTIVA_KEY);
    }
  } catch {
    // Sin almacenamiento (modo privado): la selección vive solo en memoria.
  }
}

export function clearStoredSession(): void {
  window.sessionStorage.removeItem(SESSION_KEY);
  // Al cerrar sesión se olvida la inmobiliaria elegida (TC-47).
  writeInmobiliariaActiva(null);
}

export { SESSION_KEY, INMOBILIARIA_ACTIVA_KEY };
